import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import SocialLogin from "../components/SocialLogin";
import PlacesAutocomplete from "../common/PlacesAutocomplete";
import logoIcon from "../assets/images/logo-icon.png";
import { Link, useNavigate } from "react-router-dom";
import AuthSplashLayout from "../components/AuthSplashLayout";
import ApiCall from "../common/ApiCall";

const AuthSplashView = ({ splashContent, setIsSplashActive, logo }) => {
  return (
    <AuthSplashLayout>
      <div>
        <div className="logo_box">
          <img src={logo || logoIcon} alt="Logo" />
        </div>
        <div className="center_whitebox">
          <div className="text">
            {splashContent ? (
              <div dangerouslySetInnerHTML={{ __html: splashContent }} />
            ) : (
              <>
                <p>Welcome to DreamClouds!</p>
                <p>The beta will be live soon on February 10th.</p>
              </>
            )}
          </div>
        </div>
      </div>
    </AuthSplashLayout>
  );
};

export default AuthSplashView;
